/**
 * Returns a list with nonPassive exceptions for the Turkish passive voice assessment.
 * @returns {Array}             The list with non-passive words
 */
const nonPassivesFullForms = [
	"övünür",
	"tutuş",
	"kullanmak",
	"lanmak",
	"baglanmak",
	"alinmak",
	"bosanmak",
	"kaçinmak",
	"hazirlanmak",
	"lunmak",
	"siginmak",
	"tasinmak",
	"rlanmak",
	"sakinmak",
	"zanmak",
	"tirmanmak",
	"inanmak",
	"arinmak",
	"kulllanmak",
	"isinmak",
	"yikanmak",
	"ögrenmek",
	"ogrenmek",
	"düsünmek",
	"renmek",
	"dusunmek",
	"ünmek",
	"donmek",
	"deginmek",
	"eglenmek",
	"lenmek",
	"öğünmek",
	"deyinmek",
	"örenmek",
	"gorunmek",
	"oğrenmek",
	"guvenmek",
	"begenmek",
	"şünmek",
	"nmek",
	"gecinmek",
	"tukenmek",
	"kabüllenmek",
	"öirenmek",
	"kabulenmek",
	"sinir",
	"peynir",
	"münir",
	"alinir",
	"kazanir",
	"yorumlanir",
	"kullanir",
	"uygulanir",
	"dayanir",
	"saglanir",
	"inanir",
	"özenir",
	"lenir",
	"ögrenir",
	"tersinir",
	"yasanir",
	"toplanir",
	"tanir",
	"senir",
	"rastlanir",
	"renir",
	"munir",
	"kaynaklanir",
	"baglanir",
	"hazirlanir",
	"güvenir",
	"enir",
	"soylenir",
	"baslanir",
	"davranir",
	"kapanir",
	"oynanir",
	"uzanir",
	"tanimlanir",
	"taninir",
	"souvenir",
	"ogrenir",
	"tasinir",
	"konteynir",
	"uyanir",
	"begenir",
	"hesaplanir",
	"sanir",
	"saklanir",
	"yakalanir",
	"aranir",
	"algilanir",
	"hoslanir",
	"karsilanir",
	"tamamlanir",
	"mounir",
	"yayinlanir",
	"yikanir",
	"tekrarlanir",
	"atanir",
	"bnir",
	"karasenir",
	"indüklenir",
	"zorlanir",
	"avenir",
	"erdenir",
	"kas-sinir",
	"utanir",
	"ültanir",
	"katlanir",
	"beyazpeynir",
	"sekillenir",
	"sonuçlanır",
	"dogranir",
	"nwanir",
	"faydalanir",
	"kilinir",
	"hizlanir",
	"yararlanir",
	"kutlanir",
	"saptanir",
	"nedenir",
	"kalinir",
	"ayarlanir",
	"kiskanir",
	"hastalanir",
	"suvenir",
	"yapilabilinir",
	"canlanir",
	"ekillenir",
	"hacklenir",
	"inir",
	"haslanir",
	"sonuclanir",
	"resetlenir",
	"beyenir",
	"açiklanir",
	"programming-sinir",
	"isinir",
	"odaklanir",
	"pionir",
	"çalinir",
	"penir",
	"tutuklanir",
	"lanmalı",
	"ögrenmeli",
	"düsünmeli",
	"ünmeli",
	"lanmaz",
	"osanmaz",
	"hoslanmaz",
	"üşenmez",
	"üşenmez",
	"üşenmez",
	"taşınmaz",
	"sınmaz",
	"yinmez",
	"hükmolunmaz",
	"bölünmez",
	"görünmez",
	"görüntülüyebilmek",
	"sen-ebilmek",
	"gorebilmek",
	"abilmek",
	"layabilmek",
	"ulasabilmek",
	"rabilmek",
	"saglayabilmek",
	"yaşabilmek",
	"tirebilmek",
	"tirebilmek",
	"tanılır",
	"sayılır",
	"olabılır",
	"kulanılır",
	"anlasılır",
	"lanılır",
	"acılır",
	"kimbilir",
	"labilir",
	"yapilir",
	"kullanilir",
	"yapilabilir",
	"kullanilabilir",
	"sayilir",
	"bilir",
	"anlasilir",
	"işbilir",
	"abilir",
	"ebilir",
	"nabilir",
	"ayrilir",
	"tirilir",
	"lanabilir",
	"ilir",
	"gorebilir",
	"guvenilir",
	"çikabilir",
	"alinabilir",
	"layabilir",
	"kabilir",
	"sayilabilir",
	"tartisilir",
	"yazilir",
	"rabilir",
	"açilir",
	"tirilebilir",
	"cikabilir",
	"lebilir",
	"atilir",
	"saglayabilir",
	"rilir",
	"katilir",
	"degisebilir",
	"acilir",
	"saglanabilir",
	"acabilir",
	"anlasilabilir",
	"degerlendirilir",
	"tirebilir",
	"anlatilir",
	"adlandirilir",
	"gorulebilir",
	"düsünülebilir",
	"olusabilir",
	"yabilir",
	"ulasabilir",
	"yaşabilir",
	"duyrulur",
	"buyrulur",
	"pulur",
	"gorulur",
	"olusturulur",
	"konusulur",
	"turulur",
	"rülür",
	"külür",
	"düsünülür",
	"büyülüyor",
	"görüntülüyor",
	"kötülüyor",
	"törpülüyor",
	"düsünülüyor",
	"acıldı",
	"imambayıldı",
	"rıldı",
	"tıldı",
	"ıldı",
	"anlasıldı",
	"degıldı",
	"dagıldı",
	"acıldı",
	"imambayıldı",
	"rıldı",
	"tıldı",
	"anlasıldı",
	"degıldı",
	"dagıldı",
	"degildi",
	"yapildi",
	"ayrildi",
	"deildi",
	"ögrenildi",
	"açildi",
	"azledildi",
	"atildi",
	"renildi",
	"cekildi",
	"rildi",
	"yazildi",
	"kullanildi",
	"lağvedildi",
	"anlasildi",
	"diildi",
	"kaldirildi",
	"Stem",
	"takildi",
	"birakildi",
	"gerçeklestirildi",
	"yayildi",
	"deyildi",
	"secildi",
	"yikildi",
	"çikarildi",
	"kapatildi",
	"kirildi",
	"ğildi",
	"baslatildi",
	"gonderildi",
	"deiildi",
	"yaratildi",
	"vahyedildi",
	"dagildi",
	"duyruldu",
	"buyruldu",
	"turuldu",
	"uldu",
	"meşguldu",
	"olusturuldu",
	"konusuldu",
	"özbuldu",
	"ruldu",
	"goruldu",
	"hasanboğuldu",
	"dokuldu",
	"rüldü",
	"ünüldü",
	"büründürüldü",
	"üldü",
	"türüldü",
	"satılmış",
	"geri-bıraktırılmış",
	"yaradılmış",
	"pılmış",
	"rılmış",
	"acılmış",
	"tılmış",
	"ılmış",
	"kulanılmış",
	"çokbilmiş",
	"vaadedilmiş",
	"vahyedilmiş",
	"akdedilmiş",
	"ehlileştirilmiş",
	"azledilmiş",
	"gasbedilmiş",
	"rilmiş",
	"degilmiş",
	"hasredilmiş",
	"neshedilmiş",
	"gaspedilmiş",
	"kasdedilmiş",
	"cekilmiş",
	"lağvedilmiş",
	"yapilmiş",
	"leştirilmiş",
	"deilmiş",
	"kavrulmuş",
	"kurtulmuş",
	"buyrulmuş",
	"karşılacak",
	"acılacak",
	"kulanılacak",
	"ılacak",
	"ailecek",
	"silecek",
	"labilecek",
	"ölçüşebilecek",
	"yapilabilecek",
	"sayilabilecek",
	"abilecek",
	"kullanilabilecek",
	"gerçeklestirilecek",
	"olusabilecek",
	"layabilecek",
	"alinabilecek",
	"nabilecek",
	"çikabilecek",
	"saglayabilecek",
	"rabilecek",
	"ebilecek",
	"cekilecek",
	"secilecek",
	"turulacak",
	"olusturulacak",
	"konusulacak",
	"ulacak",
	"vukubulacak",
	"azledilmişti",
	"duyrulmuştu",
	"sergiliyordu",
	"etkiliyordu",
	"sorguluyordu",
	"büyülüyordu",
	"nasılsa",
	"degilse",
	"kurulmali",
	"düsünülmeli",
	"yılmaz",
	"kaçınılmaz",
	"eryılmaz",
	"türkyılmaz",
	"özyılmaz",
	"yanılmaz",
	"hiçyılmaz",
	"kanyılmaz",
	"küçükyılmaz",
	"kacınılmaz",
	"yavuzyılmaz",
	"ınanılmaz",
	"inanılmaz",
	"akyılmaz",
	"yamanyılmaz",
	"büyükyılmaz",
	"ağaryılmaz",
	"tartısılmaz",
	"yenilmez",
	"eğilmez",
	"vazgecilmez",
	"bilmez",
	"cekilmez",
	"yorulmaz",
	"üzülmez",
];

const nonPassiveStems = [
	"sevi",
	"giyi",
	"gezi",
	"ayrı",
	"tıka",
	"ayrı",
	"sarı",
	"övü",
	"boşa",
	"besle",
	"kırı",
	"soyu",
	"yıka",
	"süsle",
	"içle",
	"besle",
	"tara",
	"çeki",
	"çözü",
	"hazırla",
	"üzü",
	"yıkı",
	"yıka",
	"kovu",
	"sıkı",
	"söyle",
	"kaçı",
	"kapa",
	"kası",
	"koru",
	"sarsı",
	"sığı",
	"kurula",
	"yakı",
	"yoru",
	"taşı",
	"uza",
	"takı",
	"yala",
	"atı",
	"iyileş",
	"sinirle",
	"dövü",
];

export {
	nonPassivesFullForms, nonPassiveStems,
};
